import {
    URL_GET_MSG_TEMPLATE_SELECT_LIST,
    URL_GET_MSG_TEMPLATE_TASK_ACTIVE_CORPLIST,
    URL_GET_MSG_TEMPLATE_TASK_ACTIVE_LIST,
    URL_GET_NOBIND_TASKGOODS,
    URL_GET_TEMPLATE_MSG_LIST,
    URL_GET_TEMPLATE_MSG_SELECT_LIST,
    URL_SYNC_MY_TEMPLATE_LIST,
    URL_GET_TASKPOSTER_LINKINFO,
    URL_QUERY_FESTIVAL_ACTIVITYLIST,
    URL_DELETE_FESTIVAL_ACTIVITYLIST,
    URL_CREATE_FESTIVAL_ACTIVITY,
    URL_MODIFY_FESTIVAL_ACTIVITY_STATUS,
    URL_GET_FESTIVAL_ACTIVITY_DETAIL,
    URL_EDIT_FESTIVAL_ACTIVITY,
    URL_GET_UNBOUND_REDEEMCODE,
    URL_GET_TASKPOSTER_ACTIVEFANS_FORMDATA,
    URL_PUSH_TSAK_PREVIEW,
    URL_GET_GOODSORDER_CHECKER_LIST,
    URL_ADD_GOODSORDER_CHECKER,
    URL_DEL_GOODSORDER_CHECKER,
    URL_QUERY_GOODSCHECKER_ORDER,
    URL_GOODSORDER_GOODNAME_LIST,
    URL_GET_GOODSCHECKER_NAMELIST,
    URL_GET_GOODSORDER_DELIVER_RECORDLIST,
    URL_DEL_GOODSORDER_DELIVER_RECORD,
    URL_QUERY_GOODSORDER_LIST,
    URL_GET_GOODSORDER_DATASTATS,
    URL_GET_GOODSORDER_BUYERINFO,
    URL_DELIVER_GOODSORDER,
    URL_EDIT_GOODSORDER_DELIVERINFO,
    URL_UPLOAD_GOODSORDER_BULKDELIVER_DATA,
    URL_GET_SUBSTAG_LIST,
    URL_MXD_BOOST_CREATE,
    URL_MXD_BOOST_EDIT,
    URL_MXD_BOOST_LIST,
    URL_MXD_BOOST_DELETE,
    URL_MXD_BOOST_ORDER_LIST,
    URL_MXD_BOOST_ORDER_UPDATEFILLINFO,
    URL_MXD_BOOST_JOINLIST,
    URL_MXD_BOOST_STAT,
    URL_MXD_BOOST_STATEXPORT,
    URL_MXD_BOOST_INVDETAIL,
    URL_GET_SYSTEM_UPGRADE_NEWCOUNT,
    URL_VIEWCILCK_SYSTEM_UPGRADE,
    URL_MXD_DISTRI_CREATE,
    URL_MXD_DISTRI_QUERY,
    URL_MXD_DISTRI_PROMOINFO,
    URL_MXD_DISTRI_DELETE,
    URL_MXD_DISTRI_TURNOFF,
    URL_MXD_DISTRI_TURNON,
    URL_MXD_DISTRI_MODIFY,
    URL_MXD_DISTRI_RANK_EXPORT,
    URL_MXD_DISTRI_RANK,
    URL_MXD_DISTRI_INVITDETAIL,
    URL_MXD_DISTRI_STATS_EXPORT,
    URL_MXD_DISTRI_STATS,
    URL_MXD_ORDER_REFUND_AMOUNT,
    URL_MXD_DISTRI_ORDERLIST,
    URL_MXD_DISTRI_ORDERSTAT,
    URL_MXD_ORDER_DELIVERY,
    URL_MXD_DISTRI_RANKSTAT,
    URL_MXD_ORDER_SELLERAPPLYREFUND,
    URL_MXD_MFS_UPLOAD,
    URL_MXD_SPEC_GROUP_LIST,
    URL_MXD_SPEC_GROUP_CREATE,
    URL_MXD_SPEC_CREATE,
    URL_MXD_SPEC_DELETE,
    URL_MXD_BOOST_PROMOTO,
    URL_MXD_DISTRI_CHANNEL_MENULIST,
    URL_MXD_DISTRI_MENULIST,
    URL_MXD_GROUPBUY_QUERY_NORMAL,
    URL_MXD_GROUPBUY_QUERY_LADDAR,
    URL_MXD_GROUPBUY_PROMOINFO,
    URL_MXD_GROUPBUY_TURNON,
    URL_MXD_GROUPBUY_TURNOFF,
    URL_MXD_GROUPBUY_DELETE,
    URL_MXD_GROUPBUY_LADDER_DELETE,
    URL_MXD_GROUPBUY_NAMES_NORMAL,
    URL_MXD_GROUPBUY_NAMES_LADDAR,
    URL_MXD_GROUPBUY_ORDER_QUERY,
    URL_MXD_GROUPBUY_ORDER_GROUP,
    URL_MXD_GROUPBUY_STATS_NORMAL_GROUPSLIST,
    URL_MXD_GROUPBUY_STATS_NORMAL_GROUPSDATA,
    URL_MXD_GROUPBUY_STATS_LADDAR_GROUPSLIST,
    URL_MXD_GROUPBUY_STATS_LADDAR_GROUPSDATA,
    URL_MXD_GROUPBUY_CREATE,
    URL_MXD_GROUPBUY_UPDATE,
    URL_MXD_GROUPBUY_DETAIL,
    URL_MXD_GROUPBUY_ORDER_DETAIL,
    URL_MXD_GROUPBUY_STATS_GROUP_DETAIL,
    URL_MXD_GROUPBUY_STATS_LADDAR_DATA,
    URL_MXD_GROUPBUY_STATS_NORMAL_DATA,
    URL_MXD_ASSETS_STATEMENT_SUMMARY,
    URL_MXD_CONF_CUSTOMMER_SERVICE_lIST,
    URL_MXD_CONF_SUBS_BASEINFO,
    URL_MXD_REDEEMCODE_UNBINDLIST,
    URL_MXD_ASSETS_ACCOUNT_PENDING_SETTLE_LIST,
    URL_MXD_ASSETS_ACCOUNT_COPLETE_SETTLE_LIST,
    URL_MXD_CONFIG_OA_SUBS_UNBIND,
    URL_MXD_CONFIG_OA_WXAUTH,
    URL_PAYCONFIG_WX_DETAIL,
    URLMXD_SUBS_MAG_TEMPLATE_LIST,
    URL_MXD_GROUPBUY_NOTICE_ADD,
    URL_MXD_GROUPBUY_NOTICE_DETAIL,
    URL_PAYCONFIG_WX_STATUS
} from "./variables";
import {FetchUtil} from "./fetch_util";

let fetchUtil = new FetchUtil();

class Api {

    static doGet(url, success, error) {

        fetchUtil.init()
            .setUrl(url)
            .setMethod("GET")
            .setCookieCors()
            .setBodyType('json')
            .dofetch()
            .then((msg) => {
                if (msg.respCode == 0) {
                    if (success) {
                        success(msg.respMsg)
                    }
                } else {
                    if (error) {
                        error(msg)
                    }
                }
            })
            .catch((msg) => {
                if (error) {
                    error(msg)
                }
            })
    }

    static doGet1(url, success, error) {

        fetchUtil.init()
            .setUrl(url)
            .setMethod("GET")
            .setCookieCors()
            // .setBodyType('text')
            .setReturnType('text')
            .dofetch()
            .then((msg) => {
                // if (msg.respCode == 0) {
                if (success) {
                    success(msg)
                }
                // } else {
                if (error) {
                    error(msg)
                }
                // }
            })
            .catch((msg) => {
                if (error) {
                    error(msg)
                }
            })
    }

    static doPost(url, bodyType, bodyData, success, error) {
        fetchUtil.init()
            .setUrl(url)
            .setMethod("POST")
            .setCookieCors()
            .setBodyType(bodyType)
            .setBody(bodyData)
            .dofetch()
            .then((msg) => {
                if (msg.respCode == 0) {
                    if (success) {
                        success(msg.respMsg)
                    }
                } else {
                    if (error) {
                        error(msg)
                    }
                }
            })
            .catch((msg) => {
                if (error) {
                    error(msg)
                }
            })
    }

    static syncMsgTemplateList(appId, success, error) {
        fetchUtil.init()
            .setUrl(URL_SYNC_MY_TEMPLATE_LIST + "?appId=" + appId)
            .setMethod("POST")
            .setCookieCors()
            .setBodyType('json')
            .dofetch()
            .then((data) => {
                if (success) {
                    success(data)
                }
            })
            .catch((err) => {
                if (error) {
                    error(err);
                }
            })
    }

    static getMsgTemplateList(success, error) {
        fetchUtil.init()
            .setUrl(URL_GET_MSG_TEMPLATE_SELECT_LIST)
            .setMethod('GET')
            .setCookieCors()
            .dofetch()
            .then((data) => {
                if (data.respCode == 0) {
                    if (success) {
                        success(data.respMsg);
                    } else if (error) {
                        error();
                    }
                }
            })
            .catch(() => {
                if (error) {
                    error();
                }
            });
    }

    static getTemplateMsgSelectList(pageNum, success, error) {
        fetchUtil.init()
            .setUrl(URL_GET_TEMPLATE_MSG_SELECT_LIST + '?pageNum=' + pageNum)
            .setMethod('GET')
            .setCookieCors()
            .dofetch()
            .then((data) => {
                if (data.respCode == 0) {
                    if (success) {
                        success(data.respMsg)
                    }
                } else if (error) {
                    error(data)
                }
            })
            .catch(() => {
                if (error) {
                    error()
                }
            })
    }

    static getTemplateMsgList(pageNum, success, error) {
        fetchUtil.init()
            .setUrl(URL_GET_TEMPLATE_MSG_LIST + '?pageNum=' + pageNum)
            .setMethod('GET')
            .setCookieCors()
            .dofetch()
            .then((data) => {
                if (data.respCode == 0) {
                    if (success) {
                        success(data.respMsg)
                    }
                } else if (error) {
                    error(data)
                }
            })
            .catch(() => {
                if (error) {
                    error()
                }
            })
    }

    static getSubsList(success, error) {
        fetchUtil.init()
            .setUrl(URL_GET_MSG_TEMPLATE_TASK_ACTIVE_LIST)
            .setMethod('GET')
            .setCookieCors()
            .dofetch()
            .then((data) => {
                if (data.respCode == 0) {
                    if (success) {
                        success(data.respMsg)
                    }
                } else if (error) {
                    error(data)
                }
            })
            .catch(() => {
                if (error) {
                    error()
                }
            })
    }

    static getCorpSubsList(success, error) {
        fetchUtil.init()
            .setUrl(URL_GET_MSG_TEMPLATE_TASK_ACTIVE_CORPLIST)
            .setMethod('GET')
            .setCookieCors()
            .dofetch()
            .then((data) => {
                if (data.respCode == 0) {
                    if (success) {
                        success(data.respMsg)
                    }
                } else if (error) {
                    error(data)
                }
            })
            .catch(() => {
                if (error) {
                    error()
                }
            })
    }

    /**
     * 获取没有绑定任务的商品
     * @param success
     * @param error
     */
    static getNoBindTaskGoodsList(success, error) {
        fetchUtil.init()
            .setUrl(URL_GET_NOBIND_TASKGOODS)
            .setMethod('GET')
            .setCookieCors()
            .dofetch()
            .then((data) => {
                if (success) {
                    success(data)
                }
            })
            .catch((err) => {
                if (error) {
                    error(err)
                }
            })
    }

    static getTpLinkInfo(taskposterId, fansId, success, error) {
        fetchUtil.init()
            .setUrl(URL_GET_TASKPOSTER_LINKINFO + "?taskposterId=" + taskposterId + "&fansId=" + fansId)
            .setMethod('GET')
            .setCookieCors()
            .dofetch()
            .then((data) => {
                if (success) {
                    success(data)
                }
            })
            .catch((err) => {
                if (error) {
                    error(err)
                }
            })
    }

    /**
     * 获取节日签活动列表
     * @param params
     * @param success
     * @param error
     */
    static getfestivalSignActivityList(params, success, error) {
        let bodyData = params.bodyData;
        let pageNum = params.pageNum;
        let pageSize = params.pageSize;
        this.doPost(URL_QUERY_FESTIVAL_ACTIVITYLIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error);
    }

    /**
     * 删除节日签活动
     * @param activityId
     * @param success
     * @param error
     */
    static deleteFestivalSignActivity(activityId, success, error) {
        this.doPost(URL_DELETE_FESTIVAL_ACTIVITYLIST + '?activityId=' + activityId, 'json', {}, success, error)
    }

    /**
     * 创建节日签活动
     * @param data
     * @param success
     * @param error
     */
    static createFestivalSignActivity(data, success, error) {
        this.doPost(URL_CREATE_FESTIVAL_ACTIVITY, 'json', data, success, error)
    }

    /**
     * 获取系统更新数量
     * @param success
     * @param error
     */
    static getUpgradeNewCount(success, error) {
        Api.doGet(URL_GET_SYSTEM_UPGRADE_NEWCOUNT, success, error);
    }

    /**
     * 更新日志点击
     * @param success
     * @param error
     */
    static upgradeViewClick(success, error) {
        Api.doPost(URL_VIEWCILCK_SYSTEM_UPGRADE, 'json', {}, success, error);
    }


    /**
     * 创建节日签活动
     * @param data
     * @param success
     * @param error
     */
    static editFestivalSignActivity(data, success, error) {
        this.doPost(URL_EDIT_FESTIVAL_ACTIVITY, 'json', data, success, error)
    }

    /**
     * 修改节日签过段状态
     * @param activityId
     * @param status
     * @param success
     * @param error
     */
    static modifyFestivalSignActivityStatus(activityId, status, success, error) {
        this.doPost(URL_MODIFY_FESTIVAL_ACTIVITY_STATUS + '?activityId=' + activityId + '&status=' + status, 'json', {}, success, error)
    }

    /**
     * 获取节日签活动详情
     * @param activityId
     * @param success
     * @param error
     */
    static getFestivalSignActivityDetail(activityId, success, error) {
        this.doGet(URL_GET_FESTIVAL_ACTIVITY_DETAIL + '?activityId=' + activityId, success, error)
    }

    /**
     * 获取任务宝粉丝表单数据
     * @param taskposterId
     * @param fansId
     * @param success
     * @param error
     */
    static getTpActiveFanFormData(taskposterId, fansId, success, error) {
        this.doGet(URL_GET_TASKPOSTER_ACTIVEFANS_FORMDATA + '?taskposterId=' + taskposterId + '&fansId=' + fansId, success, error)
    }

    /**
     * 获取未绑定兑换码列表
     * @param bindType
     * @param bindInfo
     * @param success
     * @param error
     */
    static getUnboundRedeemCodeList(bindType, bindInfo, success, error) {
        this.doGet(URL_GET_UNBOUND_REDEEMCODE + '?bindTypeArr=' + encodeURIComponent(JSON.stringify(bindType)) + '&bindInfo=' + bindInfo, success, error)
    }

    /**
     * 获取SOP计划预览
     * @param taskId
     * @param success
     * @param error
     */
    static getSopPreviewCon(taskId, success, error) {
        this.doGet(URL_PUSH_TSAK_PREVIEW + '?taskId=' + taskId, success, error)
    }

    /**
     * 获取核销员列表
     * @param pageNum
     * @param pageSize
     * @param success
     * @param error
     */
    static getGoodsOrderCheckerList(pageNum, pageSize, success, error) {
        this.doGet(URL_GET_GOODSORDER_CHECKER_LIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, success, error)
    }

    /**
     * 添加任务商品核销员
     * @param submitData
     * @param success
     * @param error
     */
    static addGoodsOrderChecker(submitData, success, error) {
        this.doPost(URL_ADD_GOODSORDER_CHECKER, 'json', submitData, success, error);
    }

    /**
     * 删除核销员
     * @param checkerId
     * @param success
     * @param error
     */
    static delGoodsOrderChecker(checkerId, success, error) {
        this.doPost(URL_DEL_GOODSORDER_CHECKER, 'json', {checkerId: checkerId}, success, error);
    }

    /**
     * 查询核销员订单
     * @param queryParams
     * @param success
     * @param error
     */
    static queryGoodsCheckerOrderList(queryParams, pageNum, pageSize, success, error) {
        this.doPost(URL_QUERY_GOODSCHECKER_ORDER + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', queryParams, success, error);
    }

    /**
     * 获取任务商品名称列表
     * @param success
     * @param error
     */
    static getGoodsNameList(success, error) {
        this.doGet(URL_GOODSORDER_GOODNAME_LIST, success, error);
    }

    /**
     * 获取任务商品核销员名称列表
     * @param success
     * @param error
     */
    static getGoodsOrderCheckerNameList(success, error) {
        this.doGet(URL_GET_GOODSCHECKER_NAMELIST, success, error);
    }

    /**
     * 获取任务商品批量发货记录
     * @param pageNum
     * @param pageSize
     * @param success
     * @param error
     */
    static getGoodsOrderDeliverRecordList(pageNum, pageSize, success, error) {
        this.doGet(URL_GET_GOODSORDER_DELIVER_RECORDLIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, success, error);
    }

    /**
     * 删除任务商品批量发货记录
     * @param id
     * @param success
     * @param error
     */
    static delGoodsOrderDeliverRecord(id, success, error) {
        this.doPost(URL_DEL_GOODSORDER_DELIVER_RECORD, 'json', {id: id}, success, error);
    }

    /**
     * 获取商品订单
     * @param queryParams
     * @param pageNum
     * @param pageSize
     * @param success
     * @param error
     */
    static getGoodsOrderList(queryParams, pageNum, pageSize, success, error) {
        this.doPost(URL_QUERY_GOODSORDER_LIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', queryParams, success, error);
    }

    /**
     * 获取订单数据统计
     * @param success
     * @param error
     */
    static getGoodsOrderDataStats(success, error) {
        this.doGet(URL_GET_GOODSORDER_DATASTATS, success, error);
    }

    /**
     * 获取订单用户信息
     * @param orderId
     * @param success
     * @param error
     */
    static getGoodsOrderBuyerFillInfo(orderId, success, error) {
        this.doGet(URL_GET_GOODSORDER_BUYERINFO + '?orderId=' + orderId, success, error);
    }

    /**
     * 任务商品订单发货
     * @param param
     * @param success
     * @param error
     */
    static deliverGoodsOrder(param, success, error) {
        Api.doPost(URL_DELIVER_GOODSORDER, 'json', param, success, error);
    }

    /**
     * 编辑任务商品发货信息
     * @param editInfo
     * @param success
     * @param error
     */
    static editGoodsOrderDeliverInfo(editInfo, success, error) {
        Api.doPost(URL_EDIT_GOODSORDER_DELIVERINFO, 'json', editInfo, success, error);
    }

    /**
     * 上传任务商品订单批量发货数据
     * @param param
     * @param success
     * @param error
     */
    static uploadGoodsOrderDeliverData(param, success, error) {
        Api.doPost(URL_UPLOAD_GOODSORDER_BULKDELIVER_DATA, 'file', param, success, error);
    }

    /**
     * 获取标签列表
     * @param appId
     * @param success
     * @param error
     */
    static getSubsFansTag(appId, success, error) {
        Api.doGet(URL_GET_SUBSTAG_LIST + "?appId=" + appId, success, error);
    }

    /**
     * 上传一元解锁新增活动数据
     * @param param
     * @param success
     * @param error
     */
    static uploadPriceUnlockAddData(param, success, error) {
        Api.doPost(URL_MXD_BOOST_CREATE, 'json', param, success, error);
    }

    /**
     * 上传一元解锁编辑活动数据
     * @param param
     * @param success
     * @param error
     */
    static uploadPriceUnlockEditData(param, success, error) {
        Api.doPost(URL_MXD_BOOST_EDIT, 'json', param, success, error);
    }

    /**
     * 获取一元解锁活动列表
     * @param params
     * @param bodyData
     * @param success
     * @param error
     */
    static getPrizeUnlockList(params, bodyData, success, error) {
        let pageNum = params.pageNum;
        let pageSize = params.pageSize;
        this.doPost(URL_MXD_BOOST_LIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error);
    }

    /**
     * 删除一元解锁活动列表
     * @param boostId
     * @param success
     * @param error
     */
    static deletePrizeUnlockActivity(boostId, success, error) {
        this.doGet(URL_MXD_BOOST_DELETE + '?boostId=' + boostId, success, error)
    }

    /**
     * 获取一元解锁订单列表
     * @param params
     * @param bodyData
     * @param success
     * @param error
     */
    static getPrizeUnlockOrderList(params, pageNum, pageSize, success, error) {
        let boostId = params.boostId;
        this.doPost(URL_MXD_BOOST_ORDER_LIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize + '&boostId=' + boostId, 'json', params, success, error);
    }

    // /**
    //  * 获取一元解锁订单用户信息
    //  * @param orderId
    //  * @param success
    //  * @param error
    //  */
    // static getPrizeUnlockFillInfo(orderId, success, error) {
    //     this.doGet(URL_MXD_BOOST_ORDER_UPDATEFILLINFO + '?orderId=' + orderId, success, error);
    // }

    /**
     * 获取一元解锁粉丝列表
     * @param params
     * @param bodyData
     * @param success
     * @param error
     */
    static getPrizeUnlockFansList(params, bodyData, success, error) {
        let pageNum = params.pageNum;
        let pageSize = params.pageSize;
        this.doPost(URL_MXD_BOOST_JOINLIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error);
    }

    /**
     * 获取一元解锁数据统计
     * @param boostId
     * @param bodyData
     * @param success
     * @param error
     */
    static getPrizeUnlockDataList(boostId, bodyData, success, error) {
        this.doPost(URL_MXD_BOOST_STAT + '?&boostId=' + boostId, 'json', bodyData, success, error);
    }

    /**
     * 获取一元解锁用户邀请详情
     * @param params
     * @param bodyData
     * @param success
     * @param error
     */
    static getPrizeUnlockInvDetail(params, bodyData, success, error) {
        let pageNum = params.pageNum;
        let pageSize = params.pageSize;
        this.doPost(URL_MXD_BOOST_INVDETAIL + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error);
    }

    /**
     * 获取分销活动列表
     * @param params
     * @param bodyData
     * @param success
     * @param error
     */
    static getDisTriActivityList(params, bodyData, success, error) {
        let pageNum = params.pageNum;
        let pageSize = params.pageSize;
        this.doPost(URL_MXD_DISTRI_QUERY + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error);
    }

    /**
     * 获取渠道下拉列表
     * @param id
     * @param success
     * @param error
     */
    static getDisTriChannelActList(id, success, error) {
        this.doGet(URL_MXD_DISTRI_CHANNEL_MENULIST + '?distriId=' + id, success, error);
    }

    /**
     * 获取分销活动下拉列表
     * @param success
     * @param error
     */
    static getDisTriActList(success, error) {
        this.doGet(URL_MXD_DISTRI_MENULIST, success, error);
    }

    /**
     * 获取分销推广信息
     * @param distriId
     * @param success
     * @param error
     */
    static getDisTriPromoInfo(distriId, success, error) {
        this.doGet(URL_MXD_DISTRI_PROMOINFO + '?distriId=' + distriId, success, error);
    }

    /**
     * 删除分销活动
     * @param distriId
     * @param success
     * @param error
     */
    static deleteDisTriActivity(distriId, success, error) {
        this.doGet(URL_MXD_DISTRI_DELETE + '?distriId=' + distriId, success, error)
    }

    /**
     * 关闭分销活动
     * @param distriId
     * @param success
     * @param error
     */
    static TurnOffDisTriActivity(distriId, success, error) {
        this.doGet(URL_MXD_DISTRI_TURNOFF + '?distriId=' + distriId, success, error)
    }

    /**
     * 开启分销活动
     * @param distriId
     * @param bodyData
     * @param success
     * @param error
     */
    static TurnOnDisTriActivity(distriId, bodyData, success, error) {
        this.doPost(URL_MXD_DISTRI_TURNON + '?distriId=' + distriId, 'json', bodyData, success, error)
    }

    /**
     * 分销订单data
     * @param distriId
     * @param success
     * @param error
     */
    static getDisTriOrderStat(distriId, success, error) {
        this.doGet(URL_MXD_DISTRI_ORDERSTAT + '?distriId=' + distriId, success, error)
    }

    /**
     * 获取分销订单列表
     * @param params
     * @param bodyData
     * @param success
     * @param error
     */
    static getDisTriOrderList(params, bodyData, success, error) {
        let pageNum = params.pageNum;
        let pageSize = params.pageSize;
        this.doPost(URL_MXD_DISTRI_ORDERLIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error);
    }

    /**
     * 获取分销订单退款金额
     * @param orderId
     * @param success
     * @param error
     */
    static getDisTriOrderRefund(orderId, success, error) {
        this.doGet(URL_MXD_ORDER_REFUND_AMOUNT + '?orderId=' + orderId, success, error);
    }

    /**
     * 商家主动退款
     * @param bodyData
     * @param success
     * @param error
     */
    static doDisTriOrderRefund(bodyData, success, error) {
        this.doPost(URL_MXD_ORDER_SELLERAPPLYREFUND, 'json', bodyData, success, error);
    }

    /**
     * 分销订单商家发货
     * @param bodyData
     * @param success
     * @param error
     */
    static getDisTriOrderDelivery(bodyData, success, error) {
        this.doPost(URL_MXD_ORDER_DELIVERY, 'json', bodyData, success, error)
    }

    /**
     * 获取分销数据
     * @param params
     * @param bodyData
     * @param success
     * @param error
     */
    static getDisTriAllData(params, bodyData, success, error) {
        let distriId = params.distriId;
        let channelId = params.channelId;
        this.doPost(URL_MXD_DISTRI_STATS + '?distriId=' + distriId + '&channelId=' + channelId, 'json', bodyData, success, error);
    }

    /**
     * 获取收益排行榜数据
     * @param distriId
     * @param success
     * @param error
     */
    static getDisTriIncomeRankData(distriId, success, error) {
        this.doGet(URL_MXD_DISTRI_RANKSTAT + '?distriId=' + distriId, success, error);
    }

    /**
     * 获取收益排行榜详情
     * @param str
     * @param success
     * @param error
     */
    static getDisTriIncomeRankDetail(str, success, error) {
        this.doGet(URL_MXD_DISTRI_INVITDETAIL + '?' + str, success, error);
    }

    /**
     * 获取收益排行榜列表
     * @param params
     * @param bodyData
     * @param success
     * @param error
     */
    static getDisTriIncomeRankList(params, bodyData, success, error) {
        let pageNum = params.pageNum;
        let pageSize = params.pageSize;
        this.doPost(URL_MXD_DISTRI_RANK + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error);
    }

    /**
     * 获取收益排行榜导出
     * @param str
     * @param success
     * @param error
     */
    static getDisTriIncomeRankExport(str, success, error) {
        this.doGet(URL_MXD_DISTRI_RANK_EXPORT + '?' + str, success, error);
    }

    /**
     * 获取普通拼团列表
     * @param params
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupBuyActivityList(params, bodyData, success, error) {
        let pageNum = params.pageNum;
        let pageSize = params.pageSize;
        this.doPost(URL_MXD_GROUPBUY_QUERY_NORMAL + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error);
    }

    /**
     * 获取阶梯拼团列表
     * @param params
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupBuyLadderActivityList(params, bodyData, success, error) {
        let pageNum = params.pageNum;
        let pageSize = params.pageSize;
        this.doPost(URL_MXD_GROUPBUY_QUERY_LADDAR + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error);
    }

    /**
     * 获取拼团推广信息
     * @param id
     * @param success
     * @param error
     */
    static getGroupBuyPromoInfo(id, success, error) {
        this.doGet(URL_MXD_GROUPBUY_PROMOINFO + '?groupbuyId=' + id, success, error);
    }

    /**
     * 开启拼团活动
     * @param id
     * @param bodyData
     * @param success
     * @param error
     */
    static TurnOnGroupBuyActivity(bodyData, success, error) {
        this.doPost(URL_MXD_GROUPBUY_TURNON, 'json', bodyData, success, error)
    }

    static TurnOffGroupBuyActivity(id, success, error) {
        this.doPost(URL_MXD_GROUPBUY_TURNOFF + '?groupbuyId=' + id, 'json', {}, success, error)
    }

    /**
     * 删除拼团活动
     * @param id
     * @param success
     * @param error
     */
    static deleteGroupBuyActivity(id, success, error) {
        this.doPost(URL_MXD_GROUPBUY_DELETE + '?groupbuyId=' + id, 'json', {}, success, error)
    }

    /**
     * 删除拼团活动阶梯
     * @param bodyData
     * @param success
     * @param error
     */
    static deleteGroupBuyLadderActivity(bodyData, success, error) {
        this.doPost(URL_MXD_GROUPBUY_LADDER_DELETE, 'json', bodyData, success, error)
    }

    /**
     * 获取拼团活动下拉列表
     * @param success
     * @param error
     */
    static getGroupBuyActList(type, success, error) {
        if (type == 'ladder') {
            this.doGet(URL_MXD_GROUPBUY_NAMES_LADDAR, success, error);
        } else {
            this.doGet(URL_MXD_GROUPBUY_NAMES_NORMAL, success, error);
        }
    }

    /**
     * 获取拼团订单列表
     * @param params
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupBuyOrderList(params, bodyData, success, error) {
        let pageNum = params.pageNum;
        let pageSize = params.pageSize;
        let groupbuyType = params.groupbuyType;
        this.doPost(URL_MXD_GROUPBUY_ORDER_QUERY + '?pageNum=' + pageNum + '&pageSize=' + pageSize + '&groupbuyType=' + groupbuyType, 'json', bodyData, success, error);
    }

    static getGroupBuyOrderGroup(id, success, error) {
        this.doGet(URL_MXD_GROUPBUY_ORDER_GROUP + '?groupId=' + id, success, error);
    }

    static getGroupBuyGroupList(params, bodyData, success, error) {
        let pageNum = params.pageNum;
        let pageSize = params.pageSize;
        this.doPost(URL_MXD_GROUPBUY_STATS_NORMAL_GROUPSLIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error);
    }

    static getGroupBuyLadderGroupList(params, bodyData, success, error) {
        let pageNum = params.pageNum;
        let pageSize = params.pageSize;
        this.doPost(URL_MXD_GROUPBUY_STATS_LADDAR_GROUPSLIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error);
    }

    static getGroupBuyGroupData(id, success, error) {
        this.doGet(URL_MXD_GROUPBUY_STATS_NORMAL_GROUPSDATA + '?groupbuyId=' + id, success, error);
    }

    static getGroupBuyLadderGroupData(id, success, error) {
        this.doGet(URL_MXD_GROUPBUY_STATS_LADDAR_GROUPSDATA + '?groupbuyId=' + id, success, error);
    }

    static getGroupBuyGroupDetail(str, id, success, error) {
        this.doPost(URL_MXD_GROUPBUY_STATS_GROUP_DETAIL + str, 'json', {'groupId': id}, success, error);
    }

    //创建拼团活动
    static getGroupBuyAllData(type, bodyData, success, error) {
        if (type == 'ladder') {
            this.doPost(URL_MXD_GROUPBUY_STATS_LADDAR_DATA, 'json', bodyData, success, error);
        } else {
            this.doPost(URL_MXD_GROUPBUY_STATS_NORMAL_DATA, 'json', bodyData, success, error);
        }
    }

    static createGroupBuyData(params, success, error) {
        this.doPost(URL_MXD_GROUPBUY_CREATE, 'json', params, success, error)
    }

    static editGroupBuyData(params, success, error) {
        this.doPost(URL_MXD_GROUPBUY_UPDATE, 'json', params, success, error)
    }

    static getGroupBuyData(id, success, error) {
        this.doGet(URL_MXD_GROUPBUY_DETAIL + '?groupbuyId=' + id, success, error)
    }

    static getGroupBuyOrderDetail(id, success, error) {
        this.doGet(URL_MXD_GROUPBUY_ORDER_DETAIL + '?orderId=' + id, success, error)
    }

    //资产管理  结算记录接口
    static getPendingSettleList(str, bodyData, success, error) {

        this.doPost(URL_MXD_ASSETS_ACCOUNT_PENDING_SETTLE_LIST + '?' + str, 'json', bodyData, success, error);
    }

    static getCompleteSettleList(str, bodyData, success, error) {

        this.doPost(URL_MXD_ASSETS_ACCOUNT_COPLETE_SETTLE_LIST + '?' + str, 'json', bodyData, success, error);
    }

    static getAssetsSummaryDetail(str, params, success, error) {
        this.doPost(URL_MXD_ASSETS_STATEMENT_SUMMARY + str, 'json', params, success, error)
    }

    static getKFList(str, success, error) {
        this.doGet(URL_MXD_CONF_CUSTOMMER_SERVICE_lIST + str, success, error)
    }

    static getMxdConfSubsBaseInfo(success, error) {
        this.doGet(URL_MXD_CONF_SUBS_BASEINFO, success, error)
    }

    static getMxdReDeemCode(str, success, error) {
        this.doGet(URL_MXD_REDEEMCODE_UNBINDLIST + str, success, error)
    }

    // 配置接口
    static getMxdConfigSubsUnbind(params, success, error) {
        this.doPost(URL_MXD_CONFIG_OA_SUBS_UNBIND, 'json', params, success, error)
    }

    //公众号微信扫码登录
    static getMxdConfigSubScribe(success, error) {
        this.doGet1(URL_MXD_CONFIG_OA_WXAUTH, success, error)
    }

    //支付配置接口
    static getMxdConfigWxPay(success, error) {
        this.doGet(URL_PAYCONFIG_WX_DETAIL, success, error)
    }

    static getMxdConfigWxStatus(params, success, error) {
        this.doPost(URL_PAYCONFIG_WX_STATUS, 'json', params, success, error)
    }

    static getSubscription(success, error) { //模板消息公用
        this.doGet(URL_MXD_CONF_SUBS_BASEINFO, success, error)
    }

    static getMsgTemp(appId, success, error) {//模板消息公用
        this.doGet(URLMXD_SUBS_MAG_TEMPLATE_LIST + '?appId=' + appId, success, error)
    }

    static submitMsgTemp(params, success, error) {
        this.doPost(URL_MXD_GROUPBUY_NOTICE_ADD, 'json', params, success, error)
    }

    static getNoticeDetail(appId, success, error) {
        this.doGet(URL_MXD_GROUPBUY_NOTICE_DETAIL + '?appId=' + appId, success, error)
    }
}

export default Api